
import { Button, notification } from 'antd';

import Config from "./../config";

class ApiContainer {
  openNotificationWithIcon(type, message = "", description = "") {
    notification[type]({ message: message, description: description });
  }
  getCurrentUser(){
     let token = localStorage.getItem("ef_token");
    if (!token) {
       window.location.replace("/");
      return;
    }
   
    return fetch(Config.api + `/api/getCurrentUser?token=${token}`, {
        headers: {
            "Content-Type": "application/json",
            // "x-access-token": localStorage.getItem("ef_token")
        }
        }).then(response => response.json())
        .then(data => {
          console.log("getCurrentUser",data);
          if (data.resultCode == 40300) {
            localStorage.removeItem("ef_token");
            window.location.replace("/");
          }
        if (data.resultCode == 20000) {
            return data.data;
        } else {
            return false;
        }
        }, err => {
          console.log("getCurrentUser", err);
          if (err.resultCode == 40300) {
            localStorage.removeItem("ef_token");
          }
            return false;
        });
    }

  login(username, password) {
    localStorage.removeItem("ef_token");
    let data = { username: username, password: password };
    return fetch(Config.api + "/api/login", {
      method: "POST", // or 'PUT'
      body: JSON.stringify(data), // data can be `string` or {object}!
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(response => response.json())
      .then(
        data => {
          if (data.resultCode == 20000) {
            this.openNotificationWithIcon("success", "Success");
            return data.data;
          } else {
            this.openNotificationWithIcon(
              "error",
              "Error",
              "username or password is not available."
            );
            return false;
          }
        },
        err => {
          this.openNotificationWithIcon(
            "error",
            "Error",
            "username or password is not available."
          );
          return false;
        }
      );
  }

  logout() {
    console.log("Logging out");
    localStorage.removeItem("_token");
    return;
  }
}

export default new ApiContainer();



// WEBPACK FOOTER //
// ./src/services/AuthService.js